// extracted by mini-css-extract-plugin
export var box = "List-module--box--48127";
export var box_md = "List-module--box_md--69746";
export var box_xmd = "List-module--box_xmd--205d6";
export var box_flex = "List-module--box_flex--fa599";
export var box_lg = "List-module--box_lg--5888b";
export var box_sm = "List-module--box_sm--02e8e";
export var box_outer = "List-module--box_outer--6bfd9";
export var box_whiteBg = "List-module--box_white-bg--b7397";
export var box_noMarginBottom = "List-module--box_no-margin-bottom--2233d";
export var box_noPadding = "List-module--box_no-padding--d9573";
export var box_outerGray = "List-module--box_outer-gray--1e743";
export var box_dark = "List-module--box_dark--f1401";
export var box_zIndex = "List-module--box_z-index--5cf94";
export var box_zIndex6 = "List-module--box_z-index-6--533d2";
export var box_eventsWithLine = "List-module--box_events-with-line--c4e0b";
export var box_featuresAo = "List-module--box_features-ao--3c9ba";
export var box_verticalPaddings = "List-module--box_vertical-paddings--b3214";
export var clearP = "List-module--clearP--2a3ee";
export var clearP_vc = "List-module--clearP_vc--d84dd";
export var list = "List-module--list--23a2e";
export var item = "List-module--item--005de";
export var itemWrapper = "List-module--itemWrapper--fb8c1";
export var checked = "List-module--checked--d4ffb";
export var colored = "List-module--colored--e3135";
export var white = "List-module--white--a095f";
export var lg = "List-module--lg--e56bf";
export var md = "List-module--md--88a10";
export var fadeInAnimation = "List-module--fadeInAnimation--dc58b";
export var placeHolderShimmer = "List-module--placeHolderShimmer--31e87";